var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "32", height: "32", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
    React.createElement("path", { className: (styles["st0"] || "st0") + " " + (styles["burger-line-1"] || "burger-line-1"), d: "M1.9 7h28.3c1 0 1.9.8 1.9 1.9 0 1-.8 1.9-1.9 1.9H1.9C.8 10.7 0 9.9 0 8.9 0 7.8.8 7 1.9 7z" }),
    React.createElement("path", { className: (styles["st0"] || "st0") + " " + (styles["burger-line-2"] || "burger-line-2"), d: "M1.9 21.8h28.3c1 0 1.9.8 1.9 1.8s-.8 1.9-1.9 1.9H1.9c-1 0-1.9-.8-1.9-1.9 0-1 .8-1.8 1.9-1.8z" }),
    React.createElement("path", { className: (styles["st0"] || "st0") + " " + (styles["burger-line-3"] || "burger-line-3"), d: "M1.9 14.4h28.3c1 0 1.9.8 1.9 1.8s-.8 1.9-1.9 1.9H1.9c-1 0-1.9-.8-1.9-1.9 0-1 .8-1.8 1.9-1.8z" })
  );
});